import React from "react";
import Axios from "../config/AxiosConfig";
import RichTextEditor from "./Editor/Editor";
import {
  EditorState,
  convertToRaw,
  AtomicBlockUtils,
} from "draft-js";
import Header from "./Header";
import helpers from "./helpers/index";
import Cookies from "universal-cookie";
import FeedDetailComponent from "./reusable/FeedDetailComponent";
import Modal from "react-awesome-modal";

const cookies = new Cookies();

export default class AdminPostCreate extends React.Component {
  state = {
    feed_title: "",
    feed_subtitle: "",
    feed_brief: "",
    feed_description: EditorState.createEmpty(),
    feed_activation: false,
    feed_show_in_app: true,
    feed_show_in_web: false,
    curated_by: "",
    feed_share_message: "",
    feed_image: {
      file: "#",
    },
    feed_detail_image: {
      file: "#",
    },
    feed_description_image: {
      file: "#",
    },
    show_to_league: true,
    league_id: null,
    error: "",
    preview: false,
    visible: false,
    feed_url: ''
  };
  getContentAsRawJson(editorState) {
    const contentState = editorState.getCurrentContent();
    const raw = convertToRaw(contentState);

    return JSON.stringify(raw);
  }
  checkError = (feed_object) => {
    for (const key in feed_object) {
      if (feed_object.hasOwnProperty(key)) {
        const element = feed_object[key];
        console.log("element", key, element);

        if (key === "feed_description") {
          const is_description_has_value = helpers.checkEditorStateHasValue(
            feed_object[key]
          );
          console.log(is_description_has_value);
          if (!is_description_has_value) {
            this.setState({
              error: `${key} must have some value!!`,
            });
            return false;
          } else {
            return true;
          }
        }
        if (key === "feed_image" || key === "feed_detail_page_image") {
          const is_image_in_base64_format = helpers.checkImageIsInCorrectFormat(
            feed_object[key]
          );
          if (is_image_in_base64_format) {
            this.setState({
              error: `please upload images!!`,
            });
            return false;
          } else {
            return true;
          }
        }
        if (element === "" || element === "#") {
          this.setState({
            error: `${key} must have some value!!`,
          });
          return false;
        }
      } else {
        return true;
      }
    }
  };
  createFeed = async (data) => {
    let feed_object = {
      feed_title: this.state.feed_title,
      feed_subtitle: this.state.feed_subtitle,
      feed_brief: this.state.feed_brief,
      feed_description: this.getContentAsRawJson(this.state.feed_description),
      is_active: this.state.feed_activation || false,
      is_visible_on_app: this.state.feed_show_in_app,
      is_visible_on_web: this.state.feed_show_in_web,
      feed_image: this.state.feed_image.file,
      feed_detail_page_image: this.state.feed_detail_image.file,
      post_character_count: getPostWordCount(this.state.feed_description),
      curated_by: this.state.curated_by,
      share_message: this.state.feed_share_message,
      show_to_league: this.state.show_to_league,
      league_id: this.state.league_id,
      feed_url: this.state.feed_url
    };
    const check_error = this.checkError(feed_object);
    if (check_error) {
      const create_feed = await Axios.post("/webposts", feed_object, {
        headers: {
          authorization: cookies.get("authorization"),
        },
      });
      let is_created = JSON.parse(JSON.stringify(create_feed.data));
      if (is_created.code >= 200 && is_created.code < 300) {
        this.openModal();
        this.setState({
          feed_title: "",
          feed_subtitle: "",
          feed_brief: "",
          feed_description: EditorState.createEmpty(),
          feed_activation: false,
          curated_by: "",
          feed_share_message: "",
          feed_image: {
            file: "#",
          },
          feed_detail_image: {
            file: "#",
          },
          feed_description_image: {
            file: "#",
          },
          show_to_league: false,
          league_id: null,
          feed_url: ''
        });
      }
    }
  };
  previewFeed = () => {
    this.setState({
      preview: true,
    });
  };
  handleUpload = async (image_object, image_section) => {
    console.log("image", image_object, image_section);
    if (image_object.file_name === undefined) {
      return;
    }

    let url = "/upload_image";
    const full_image_url = await Axios.post(url, image_object, {
      headers: {
        authorization: cookies.get("authorization"),
      },
    });
    if (image_section === "MAIN_IMAGE") {
      console.log("image_section", image_section);
      this.setState({ feed_image: { file: full_image_url.data.image_url } });
    } else if (image_section === "IMAGE_DETAIL") {
      this.setState({
        feed_detail_image: { file: full_image_url.data.image_url },
      });
    } else if (image_section === "IMAGE_DESC") {
      const newEditorState = this.insertImage(
        this.state.feed_description,
        full_image_url.data.image_url
      );
      this.handleEditorChange(newEditorState);
      this.setState({
        feed_description_image: { file: "#" },
      });
    } else return;
  };
  showImage = async (image_section, input) => {
    const { files } = input.target;
    if (files.length > 0) {
      const file_name =
        new Date().getTime() + files[0].name.replace(/\s/g, "-");
      const file_type = files[0].type;
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      let image_obj = {
        file_name,
        file_type,
      };
      reader.onload = async (image) => {
        image_obj.file = image.target.result;
        if (image_section === "MAIN_IMAGE") {
          image_obj.feed_title = `${this.state.feed_title.replace(
            /\s/g,
            "-"
          )}/feed_title`;
          this.setState({
            feed_image: image_obj,
          });
        } else if (image_section === "IMAGE_DETAIL") {
          image_obj.feed_title = `${this.state.feed_title.replace(
            /\s/g,
            "-"
          )}/feed_subtitle`;
          this.setState({
            feed_detail_image: image_obj,
          });
        } else if (image_section === "IMAGE_DESC") {
          image_obj.feed_title = `${this.state.feed_title.replace(
            /\s/g,
            "-"
          )}/feed_description`;
          this.setState({
            feed_description_image: image_obj,
          });
          this.handleUpload(image_obj, "IMAGE_DESC");
        }
      };
    } else {
      if (image_section === "MAIN_IMAGE") {
        this.setState({
          feed_image: "#",
        });
        return;
      } else if (image_section === "IMAGE_DETAIL") {
        this.setState({
          feed_detail_image: "#",
        });

        return;
      } else if (image_section === "IMAGE_DESC") {
        this.setState({
          feed_description_image: "#",
        });
        return;
      } else {
        return;
      }
    }
  };

  handleFeedTitleChange = (e) => {
    const { value, maxLength } = e.target;
    const message = value.slice(0, maxLength);
    if (message.length >= maxLength) {
      this.setState({
        error: "Max length can be 100 characters only",
      });
    } else {
      this.setState({
        error: "",
        feed_title: e.target.value,
      });
    }
  };

  handleEditorChange = (editor) => {
    this.setState({
      feed_description: editor,
    });
  };
  insertImage = (editorState, base64) => {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      "image",
      "IMMUTABLE",
      { src: base64 }
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(editorState, {
      currentContent: contentStateWithEntity,
    });
    return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
  };

  handleWordCount = (word_count) => {
    console.log("word_count", word_count);
  };

  openModal() {
    this.setState({
      visible: true,
    });
  }

  closeModal() {
    this.setState({
      visible: false,
    });
  }
  render() {
    if (this.state.preview) {
      return (
        <div>
          <div className="container-detail-page">
            <button
              className="btn-feed"
              style={{ float: "right" }}
              onClick={() => this.setState({ preview: false })}
            >
              Exit Preview
            </button>
          </div>
          <FeedDetailComponent
            feed_detail_page_image={this.state.feed_detail_image}
            feed_brief={this.state.feed_brief}
            editorState={this.state.feed_description}
          />
        </div>
      );
    } else {
      return (
        <div className="container">
          <Header />
          <div>
            <h2
              className="heading"
              style={{
                padding: "10px",
                marginTop: "40px",
              }}
            >
              Create Feed
            </h2>
          </div>
          <p style={{ color: "red" }}>{this.state.error}</p>
          <div className="row">
            <div className="col-25">
              <label htmlFor="feed_title">Feed Title*</label>
            </div>
            <div className="col-75">
              <input
                type="text"
                id="feed_title"
                name="title"
                value={this.state.feed_title}
                onChange={this.handleFeedTitleChange}
                placeholder="Add feed title for feed listing page.."
                maxLength="101"
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="col-25">
              <label htmlFor="feed_brief">Feed Brief*</label>
            </div>
            <div className="col-75">
              <input
                type="text"
                id="feed_brief"
                name="brief"
                value={this.state.feed_brief}
                onChange={(e) => this.setState({ feed_brief: e.target.value })}
                placeholder="Add feed brief for feed detail page.."
              />
            </div>
          </div>
          <div className="row">
            <div className="col-25">
              <label htmlFor="feed_image">Feed Image*</label>
            </div>
            <div className="col-75">
              <input
                type="file"
                id="feed_image"
                name="list-image"
                onChange={this.showImage.bind(this, "MAIN_IMAGE")}
                placeholder="Add feed image.."
              />
              <button
                className="btn-feed"
                onClick={this.handleUpload.bind(
                  this,
                  this.state.feed_image,
                  "MAIN_IMAGE"
                )}
              >
                Upload Image
              </button>
              <div
                style={{ margin: "10px 0" }}
                className={
                  this.state.feed_image.file === "#" ? "inactive-class" : ""
                }
              >
                <img
                  src={this.state.feed_image.file}
                  alt="feed-main"
                  style={{ maxWidth: "200px" }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-25">
              <label htmlFor="feed_subtitle">Feed Subtitle*</label>
            </div>
            <div className="col-75">
              <input
                type="text"
                id="feed_subtitle"
                name="subtitle"
                value={this.state.feed_subtitle}
                onChange={(e) =>
                  this.setState({ feed_subtitle: e.target.value })
                }
                placeholder="Add feed sub title for feed listing page.."
              />
            </div>
          </div>

          <div className="row">
            <div className="col-25">
              <label htmlFor="feed_description">Feed Description*</label>
            </div>
            <div className="col-75">
              <RichTextEditor
                handleEditor={this.handleEditorChange}
                editorState={this.state.feed_description}
                handleImageChange={this.showImage}
                placeholder={"Add feed description for feed detail page.."}
                wordCount={this.handleWordCount}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-25">
              <label htmlFor="feed_detail_image">Detail Page Image*</label>
            </div>
            <div className="col-75">
              <input
                type="file"
                id="feed_detail_image"
                name="detail-image"
                onChange={this.showImage.bind(this, "IMAGE_DETAIL")}
                placeholder="Add feed detail page image.."
              />
              <button
                className="btn-feed"
                onClick={this.handleUpload.bind(
                  this,
                  this.state.feed_detail_image,
                  "IMAGE_DETAIL"
                )}
              >
                Upload Image
              </button>
              <div
                style={{ margin: "10px 0" }}
                className={
                  this.state.feed_detail_image.file === "#"
                    ? "inactive-class"
                    : ""
                }
              >
                <img
                  src={this.state.feed_detail_image.file}
                  alt="feed-detail"
                  style={{ maxWidth: "200px" }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-25">
              <label htmlFor="feed_activation">Is Active</label>
            </div>
            <div className="col-75">
              <input
                type="checkbox"
                id="feed_activation"
                name="activate_feed"
                checked={this.state.feed_activation}
                onChange={(e) =>
                  this.setState({
                    feed_activation: e.target.checked,
                  })
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col-25">
              <label htmlFor="feed_league_status">Show to league</label>
            </div>
            <div className="col-75">
              <input
                type="checkbox"
                id="feed_league_status"
                name="show_to_league"
                checked={this.state.show_to_league}
                onChange={(e) =>
                  this.setState({
                    show_to_league: e.target.checked,
                  })
                }
              />
            </div>
          </div>
          {/* <div className="row">
            <div className="col-25">
              <label htmlFor="feed-show-in-app">Show in app</label>
            </div>
            <div className="col-75">
              <input
                type="checkbox"
                id="feed-show-in-app"
                name="show-in-app"
                checked={this.state.feed_show_in_app}
                onChange={(e) =>
                  this.setState({
                    feed_show_in_app: e.target.checked,
                  })
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col-25">
              <label htmlFor="feed-show-in-web">Show in web</label>
            </div>
            <div className="col-75">
              <input
                type="checkbox"
                id="feed-show-in-web"
                name="show-in-web"
                checked={this.state.feed_show_in_web}
                onChange={(e) =>
                  this.setState({
                    feed_show_in_web: e.target.checked,
                  })
                }
              />
            </div>
          </div> */}
          <div className="row">
            <div className="col-25">
              <label htmlFor="curated_by">Curated By</label>
            </div>
            <div className="col-75">
              <input
                type="text"
                id="curated_by"
                name="feed_curation"
                value={this.state.curated_by}
                placeholder="Curated by Impact"
                onChange={(e) =>
                  this.setState({
                    curated_by: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col-25">
              <label htmlFor="share_message">Share Message</label>
            </div>
            <div className="col-75">
              <input
                type="text"
                id="share_message"
                name="feed_curation"
                value={this.state.feed_share_message}
                placeholder="Share message"
                onChange={(e) =>
                  this.setState({
                    feed_share_message: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col-25">
              <label htmlFor="feed_url">Feed Url</label>
            </div>
            <div className="col-75">
              <input
                type="url"
                id="feed_url"
                name="feed_url"
                value={this.state.feed_url}
                placeholder="Feed URL"
                onChange={(e) =>
                  this.setState({
                    feed_url: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div
            style={{
              margin: "15px 0px 40px 0px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <button
              className="btn-feed"
              type="submit"
              onClick={this.previewFeed}
            >
              Preview
            </button>
            <button
              className="btn-feed"
              type="submit"
              onClick={this.createFeed}
            >
              CREATE Feed
            </button>
          </div>
          <section style={{ textAlign: "center" }}>
            <Modal
              visible={this.state.visible}
              width="270"
              height="250"
              effect="fadeInDown"
              onClickAway={() => this.closeModal()}
            >
              <div style={{ margin: "30px" }}>
                <h2 style={{ padding: "10px" }}>Create Feed</h2>
                <p style={{ padding: "10px" }}>Feed Created Successfully</p>
                <button
                  className="btn-feed"
                  style={{ padding: "10px" }}
                  onClick={() => this.closeModal()}
                >
                  Ok
                </button>
              </div>
            </Modal>
          </section>
        </div>
      );
    }
  }
}

function getPostWordCount(editorState) {
  const plainText = editorState.getCurrentContent().getPlainText("");
  const regex = /(?:\r\n|\r|\n)/g; // new line, carriage return, line feed
  const cleanString = plainText.replace(regex, " ").trim(); // replace above characters w/ space
  const wordArray = cleanString.match(/\S+/g); // matches words according to whitespace

  return wordArray ? wordArray.length : 0;
}
